module.exports = '<svg width="37" height="32" viewBox="0 0 37 32"><path d="M36.571 11.211v9.575c0 1.326-.985 2.071-2.238 2.071H18.285v7.831c0 1.323-.702 1.71-1.662.864L.712 17.534c-.965-.846-.942-2.222.018-3.067L16.607.449c.965-.846 1.678-.459 1.678.864v7.831h16.048c1.253 0 2.238.745 2.238 2.069z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-arrow-2.js
// module id = 1219
// module chunks = 14